import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Pages.css';

function About() {
  const teamMembers = [
    {
      name: 'Mitchell Brown',
      role: 'Lead Developer',
      bio: 'Mitchell designs pragmatic, high-performing solutions that prioritize security and scalability. He combines formal computer science training with real-world experience building websites, systems, and AI automation.',
      image: '/img/Mitch.jpg',
    },
    {
      name: 'Jackson Moore',
      role: 'Account Manager',
      bio: 'Jackson keeps projects organized and communication clear. He acts as the single point of contact, ensuring transparent timelines, managed expectations, and strong client relationships throughout execution.',
      image: '/img/Jack.png',
    },
    {
      name: 'Kiara Horchover',
      role: 'Creative Director',
      bio: 'Kiara designs with purpose and clarity. She combines branding, logo design, and social media expertise to create clean, effective visuals and messaging that drive engagement across platforms.',
      image: '/img/kiara.png',
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            // Unobserve after visibility to prevent repeated callbacks
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -100px 0px' }
    );

    const sections = document.querySelectorAll('.animate-on-scroll');
    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  return (
    <main className="container about-page">
      <h1 className="page-title">About VW Tech</h1>
      <p className="page-intro">Learn about our team, our mission, and what drives us to build.</p>

      {/* Our Story Card */}
      <section className="about-story-card animate-on-scroll" aria-labelledby="about-intro-heading">
        <div className="card">
          <div className="card-content">
            <div className="about-image">
              <img
                src="/img/Logo.svg"
                alt="VW Tech Solutions team"
                width="300"
                height="300"
                loading="lazy"
              />
            </div>

            <div className="about-bio">
              <h2 id="about-intro-heading">Our Story</h2>
              <p>
                VW Tech was founded to cut through the noise. We build technology that delivers real
                results—no unnecessary complexity, no buzzwords. By combining strong technical
                expertise, strategic creative direction, and clear communication, we create
                practical solutions that help businesses optimize, compete, and scale. Our process
                is transparent, our technology is intentional, and everything we build is designed
                to work—today and long term.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="about-team animate-on-scroll" aria-labelledby="team-heading">
        <h2 id="team-heading">Our Team</h2>
        <div className="team-grid">
          {teamMembers.map((member, idx) => (
            <div key={idx} className="card team-card">
              <div className="team-image">
                <img src={member.image} alt={member.name} loading="lazy" />
              </div>
              <div className="team-info">
                <h3>{member.name}</h3>
                <p className="role">{member.role}</p>
                <p>{member.bio}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Our Approach Section */}
      <section className="home-values-section animate-on-scroll" aria-labelledby="values-heading">
        <div className="container">
          <div className="card">
            <h2 id="values-heading">Our Approach</h2>
            <div className="values-grid" style={{ paddingTop: '20px', paddingBottom: '20px' }}>
              <div className="value-item">
                <span className="value-icon">🎯</span>
                <h3>Results-Driven</h3>
                <p>
                  We focus on delivering measurable outcomes that directly impact your business
                  goals.
                </p>
              </div>
              <div className="value-item">
                <span className="value-icon">🤝</span>
                <h3>Transparent</h3>
                <p>
                  Clear communication, honest timelines, and no surprises. You'll always know where
                  your project stands.
                </p>
              </div>
              <div className="value-item">
                <span className="value-icon">⚡</span>
                <h3>Pragmatic</h3>
                <p>
                  We choose the right technology for the job—not the trendy one. Practical solutions
                  that actually work.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="home-cta-section animate-on-scroll" aria-labelledby="cta-heading">
        <div className="container">
          <div className="card cta-card">
            <h2 id="cta-heading">Ready to Get Started?</h2>
            <p>Let's discuss how we can help transform your business.</p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn btn-primary">
                Schedule a Consultation
              </Link>
              <Link to="/projects" className="btn btn-secondary">
                View Our Work
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default About;
